import fetch_details from "@/apollo/cruises/details/fetch_details.gql";

export const state = () => ({
  details: {},
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Mar 2025 | 11:25AM
   * @param {*} state
   * @param {*} value
   */
  setDetails(state, value) {
    state.details = value;
  },

  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Mar 2025 | 11:25AM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Mar 2025 | 11:25AM
   * @param {*} { commit }
   * @param {*} inventory_id
   * @returns {*}
   */
  fetchDetails({ commit }, inventory_id) {
    return new Promise(async () => {
      commit("setLoading", true);
      try {
        const {
          data: { fetch_cruises_details }
        } = await this.$apolloClient.query({ query: fetch_details, variables: { inventory_id } });
        if (fetch_cruises_details) {
          commit("setLoading", false);
          commit("setDetails", fetch_cruises_details);
        }
      } catch (error) {
        commit("setLoading", false);
      }
    });
  },

  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Mar 2025 | 11:26AM
   * @param {*} { commit }
   * @param {*} inventory_id
   * @returns {*}
   */
  refreshListing({ commit }, inventory_id) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_cruises_details }`
      });
      for await (const event of _result) {
        this.$apolloClient.query({ query: fetch_details, variables: { inventory_id } }).then(({ data }) => {
          commit("setDetails", data.fetch_cruises_details);
          resolve(data.fetch_cruises_details);
        });
      }
    });
  }
};

export const getters = {
  details: (state) => state.details,
  loading: (state) => state.loading
};
